export enum PackageSelectionMethodType {
  SCANNED = 'SCANNED',
  MANUALLY_SELECTED = 'MANUALLY_SELECTED',
  MANUALLY_INSERTED = 'MANUALLY_INSERTED',
  AUTOMATICALLY_MATCHED = 'AUTOMATICALLY_MATCHED',
}
